export default __webpack_public_path__ + "static/media/1558.33c896ad.png";